import { SITE_URL } from "@/lib/seo";

export type Crumb = { name: string; path: string };

/** Səhifə üçün BreadcrumbList JSON-LD sxemi qaytarır (ilk pillə həmişə Ana səhifə). */
export function breadcrumbLd(crumbs: Crumb[]) {
  const all: Crumb[] = [{ name: "Ana səhifə", path: "/" }, ...crumbs];
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: all.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.name,
      item: `${SITE_URL}${c.path}`,
    })),
  };
}

/** Breadcrumb sxemini birbaşa route head() scripts massivinə əlavə etmək üçün. */
export function breadcrumbScript(crumbs: Crumb[]) {
  return {
    type: "application/ld+json",
    children: JSON.stringify(breadcrumbLd(crumbs)),
  };
}
